import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteVehicleWithdrawalResponsible(
  uuid: string
): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/vehicle-withdrawal-responsible/${uuid}`)
}
